/* import __COLOCATED_TEMPLATE__ from './ticket-state-category-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();